import styled from "styled-components";

export const PageName = styled.div`
  display: flex;
  height: 40px;
  align-items: center;

  @media (max-width: 700px) {
    position: absolute;
  }
`;

export const FlexLineJustify = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 700px) {
    align-items: start;
  }
`;

export const FlexLineGapSmall = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: end;
    position: relative;
    width: 100%;
  }
`;

export const Label = styled.div`
  margin-left: 5px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const InputContainer = styled.div`
  width: 300px;

  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.3rem 0.75rem;
  margin-left: 10px;
  background-color: #efebff;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};

  @media (max-width: 400px) {
    display: none;
  }
`;

export const OnlineTag = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: ${({ theme }) => theme.colors.mediumGreen};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;

export const OfflineTag = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: #cdcdcd;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;

export const ButtonBox = styled.div`
  display: flex;
  gap: 2px;
`;

export const FilterComponents = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;

  @media (max-width: 700px) {
    flex-direction: row-reverse;
    position: relative;
    width: 100%;
  }
`;
